import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { Image, Modal, ScrollView } from 'react-native';
import styled from 'styled-components/native';
import { SafeAreaWrapper } from '@/components/SafeAreaWrapper';
export default function GuideModal({ visible, guideContent, onDismissPermanently, onConfirm, onRequestClose, }) {
    if (!guideContent) {
        return null;
    }
    const { image, title, steps, additionalInfo } = guideContent;
    return (_jsx(Modal, { visible: visible, animationType: "slide", transparent: false, statusBarTranslucent: true, onRequestClose: onRequestClose, children: _jsxs(SafeAreaWrapper, { edges: ['top', 'bottom'], style: [{ flex: 1, backgroundColor: color.white }], children: [_jsx(ScrollView, { contentContainerStyle: { flexGrow: 1 }, children: _jsxs(ContentContainer, { children: [image && (_jsx(ImageWrapper, { children: _jsx(Image, { source: image, style: { width: '100%', height: '100%' }, resizeMode: "stretch" }) })), _jsxs(DescriptionSection, { children: [_jsx(TitleText, { children: title }), steps && steps.length > 0 && (_jsx(StepsContainer, { children: steps.map((step, index) => (_jsxs(React.Fragment, { children: [_jsxs(StepItem, { children: [_jsx(StepNumberCircle, { children: _jsx(StepNumber, { children: step.number }) }), _jsx(StepDescription, { children: step.description })] }), index < steps.length - 1 && _jsx(StepConnector, {})] }, step.number))) })), additionalInfo && (_jsx(AdditionalInfo, { children: additionalInfo }))] })] }) }), _jsxs(ButtonWrapper, { children: [_jsx(ButtonContainer, { children: _jsx(SccButton, { elementName: "guide_modal_dismiss", text: "\uB2E4\uC2DC\uBCF4\uC9C0 \uC54A\uAE30", onPress: onDismissPermanently, buttonColor: "gray20", textColor: "gray90", fontFamily: font.pretendardSemibold, style: { borderRadius: 12 } }) }), _jsx(ButtonContainer, { children: _jsx(SccButton, { elementName: "guide_modal_confirm", text: "\uD655\uC778\uD588\uC5B4\uC694!", onPress: onConfirm, buttonColor: "brandColor", textColor: "white", fontFamily: font.pretendardBold, style: { borderRadius: 12 } }) })] })] }) }));
}
const ContentContainer = styled.View `
  flex: 1;
  gap: 24px;
`;
const ImageWrapper = styled.View `
  max-height: 280px;
`;
const DescriptionSection = styled.View `
  padding: 0 20px 40px 20px;
  gap: 20px;
`;
const TitleText = styled.Text `
  font-size: 22px;
  line-height: 30px;
  font-family: ${font.pretendardBold};
  color: ${color.gray80};
  text-align: center;
`;
const StepsContainer = styled.View ``;
const StepItem = styled.View `
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;
const StepNumberCircle = styled.View `
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: ${color.gray15};
  align-items: center;
  justify-content: center;
`;
const StepNumber = styled.Text `
  font-size: 13px;
  font-family: ${font.pretendardMedium};
  color: ${color.gray80};
`;
const StepDescription = styled.Text `
  flex: 1;
  font-size: 18px;
  line-height: 26px;
  font-family: ${font.pretendardMedium};
  color: ${color.gray80};
`;
const StepConnector = styled.View `
  width: 2px;
  height: 20px;
  background-color: ${color.gray15};
  margin-left: 11px;
  margin-top: 4px;
  margin-bottom: 4px;
`;
const AdditionalInfo = styled.Text `
  font-size: 16px;
  line-height: 24px;
  font-family: ${font.pretendardMedium};
  color: ${color.gray90};
  background-color: ${color.gray10};
  border-radius: 14px;
  padding: 12px;
`;
const ButtonWrapper = styled.View `
  flex-direction: row;
  padding: 12px 20px;
  gap: 8px;
`;
const ButtonContainer = styled.View `
  flex: 1;
`;
